import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useStats } from '../contexts/StatsContext';
import { mockData } from '../data/mock';
import { Button } from '../components/ui/button';
import { ArrowRight, Tag, Users, Percent } from 'lucide-react';

const PricingSection = () => {
  const { t, language } = useLanguage();
  const { websitePrice } = useStats();

  // Calculate partner price (5€ less than standard)
  const partnerPrice = Math.max(parseInt(websitePrice) - 5, 30);

  const pricingCards = [
    {
      icon: Tag,
      title: t('pricing.standard.title'),
      price: `${websitePrice}€`,
      description: t('pricing.standard.description'),
      featured: true,
    },
    {
      icon: Users,
      title: t('pricing.partner.title'),
      price: `${partnerPrice}€`,
      description: t('pricing.partner.description'),
      featured: false,
    },
    {
      icon: Percent,
      title: t('pricing.group.title'),
      price: t('pricing.group.price'),
      description: t('pricing.group.description'),
      featured: false,
    },
  ];

  return (
    <section className="section-padding bg-gradient-subtle">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4">
            {t('pricing.title')}
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto">
            {language === 'de'
              ? 'Faire Preise für hochwertige Erste-Hilfe-Ausbildung'
              : 'Fair prices for high-quality first aid training'}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {pricingCards.map((card, index) => (
            <div
              key={index}
              className={`relative p-6 rounded-2xl card-hover ${
                card.featured
                  ? 'bg-white border-2 border-red-600 shadow-xl'
                  : 'bg-white border border-neutral-200'
              }`}
            >
              {card.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-full">
                  {language === 'de' ? 'Beliebt' : 'Popular'}
                </div>
              )}
              <div className="text-center">
                <div
                  className={`w-14 h-14 mx-auto mb-4 rounded-xl flex items-center justify-center ${
                    card.featured ? 'bg-red-600' : 'bg-red-50'
                  }`}
                >
                  <card.icon
                    className={`w-7 h-7 ${card.featured ? 'text-white' : 'text-red-600'}`}
                  />
                </div>
                <h3 className="text-lg font-semibold text-neutral-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-3xl font-bold text-red-600 mb-2">{card.price}</p>
                <p className="text-sm text-neutral-500">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mockData.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-3 rounded-xl group">
              <span>{t('nav.bookNow')}</span>
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
